<template>
  <div class="debug-panel">
    <div @click="infoShow = !infoShow">HiFi,{{ hifiState }}</div>
    <div v-show="infoShow">
      <div>
        <button @click="connect">connect</button>
        <button @click="disconnect">disconnect</button>
        <button @click="test">test</button>
        <br />
        wdWatch:{{ wdWatch }}
        <button @click="setWdWatch(!wdWatch)">
          Set wdWatch({{ !wdWatch }})
        </button>
        <br />
        micEnabled:{{ micEnabled }}
        <button @click="toggleMic()">Set mic({{ !micEnabled }})</button>
      </div>
      <div>
        uid:{{ uid }}
        <br />
        receiveChannel:{{ receiveChannel }}
        <br />
        wdenteringChannelName:{{ wdenteringChannelName }}
        <br />
        wdenterChannel:{{ wdenterChannelName }}
        <br />
        channelCntingTimer:{{ channelCntingTimer }},channelDcntingTimer:{{
          channelDcntingTimer
        }}
        <br />
        volumeDeleteThreshold:<input
          v-model.number="volumeDeleteThreshold"
          size="4"
        />
        <br />
        volumeThreshold:{{ volumeThreshold }}
      </div>
      <div @click="userListShow = !userListShow">
        maxUser:{{ maxUser }}, user list:{{ receivedHiFiAudioAPIData.length }}
      </div>
      <div v-show="userListShow">
        <div v-for="(item, i) in receivedHiFiAudioAPIData" :key="i">
          ID:{{ item.providedUserID }}, volume:{{ item.volumeDecibels }}
        </div>
      </div>
      <div style="display: none">
        <audio id="hifiSpeaker" controls autoplay class="outputAudioEl"></audio>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import {
  HiFiAudioAPIData,
  HiFiCommunicator,
  Point3D,
  OrientationEuler3D,
  HiFiLogger,
  HiFiLogLevel,
  UserDataSubscription,
  AvailableUserDataSubscriptionComponents,
} from "hifi-spatial-audio";

export default {
  components: { EventBus },
  name: "SpatialAudio",
  props: {
    hidePanel: { type: Boolean, default: false },
    receiveChannel: { type: String, default: "default" },
    spatial: { type: Boolean, default: false },
    uid: { type: Number, default: 1 },
    micEnabled: { type: Boolean, default: false },
    micVolume: { type: Number, default: 0.5 },
    voiceVolume: { type: Number, default: 0.8 },
    cntStatus: { type: Object, default: {} },
    HifiEnable: { type: Boolean, default: false },
    rollOff: { type: Number, default: 12 },
    wdWatch: { type: Boolean, default: false },
    speakers: { type: Array, default: [] },
    subscribeMode: { type: Boolean, default: false },
    isFirefox: { type: Boolean, default: false },
    isResetConnect: { type: Boolean, default: false },
  },
  data() {
    return {
      apiUrl: "loadbalancer-audio-0.swe-voice2.com",
      hifiCommunicator: null,
      audioMediaStream: null,
      inputDeviceId: "default",
      userDataSubscription: null,
      hiFiAudioAPIData: {},
      subComponents: [AvailableUserDataSubscriptionComponents.VolumeDecibels],
      receivedHiFiAudioAPIData: [],
      volumeDeleteThreshold: -80,
      sendHifiAudioAPIData: [],
      sendHifiAudioAPIDataFun: null,

      hifiState: "DISCONNECTED",
      hifiSDKState: "DISCONNECTED",
      channelCntingTimerFun: 0,
      channelCntingTimer: 0,
      channelDcntingTimerFun: null,
      channelDcntingTimer: 0,

      infoShow: false,
      userListShow: true,
      watchdogFun: null,
      wdenteringChannelName: "",
      wdenterChannelName: "",
      wdCheckTime: 8000,
      changeChannelDelay: false,
      maxUser: 0,
    };
  },
  computed: {
    appId() {
      let appid = "8cedba9b-9e9d-4503-a930-b46c70b53b31";
      if (true) appid = "d0cc0f3a-c8f7-4e62-9a08-3d419fa3ed43";
      return appid;
    },
    appSecret() {
      let appid = "cb56a9e4-d465-4dab-bc00-6d40517fccd1";
      if (true) appid = "f80737df-fbfc-4857-b2c4-9ab3172f982a";
      return appid;
    },
    volumeThreshold() {
      return parseInt(this.micVolume * -96);
    },
  },
  watch: {
    async micEnabled(val) {
      console.log("h micEnabled:" + val);
      this.setMute(!val);
    },
    async receiveChannel(val) {
      if (this.HifiEnable) {
        let that = this;
        console.log(
          "h receiveChannel:" + val + ", but it need watchdog to handle"
        );
        that.changeChannelDelay = true;
        clearInterval(that.watchdogFun);
        await that.disconnect();
        setTimeout(() => {
          console.log("run time out 2s");
          that.watchdog();
          that.changeChannelDelay = false;
          that.watchdogFun = setInterval(that.watchdog, that.wdCheckTime);
        }, 2000);
      }
    },
    async inputDeviceId(val) {
      if (this.hifiState == this.cntStatus.cnted) {
        console.log("hifi change input device" + val);
        if (this.audioMediaStream != null) {
          const tracks = this.audioMediaStream.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
          this.audioMediaStream = undefined;
        }
        this.audioMediaStream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: val,
            echoCancellation: true,
            echoCancellationType: { ideal: "system" },
          },
          video: false,
        });

        this.$store.commit("updateMicPermission");
        if (this.hifiCommunicator != null) {
          this.hifiCommunicator.setInputAudioMediaStream(this.audioMediaStream);
        }
      }
    },
    hifiSDKState(val) {
      console.log("watch hifiSDKState:" + val);
      if (val == this.cntStatus.cnted) {
        console.log("this.wdenteringChannelName:" + this.wdenteringChannelName);
        this.wdenterChannelName = this.wdenteringChannelName;
        console.log("this.wdenterChannelName:" + this.wdenterChannelName);
        this.wdenteringChannelName = "";
        // console.log("hifi state:set status and name")
        this.hifiState = this.cntStatus.cnted;
        console.log("this.hifiState" + this.hifiState);
        if (this.subscribeMode) {
          document.querySelector(`.outputAudioEl`).srcObject =
            this.hifiCommunicator.getOutputAudioMediaStream();
          document.querySelector(`.outputAudioEl`).play();
        }
      } else {
        this.hifiState = this.cntStatus.dcnted;
        this.wdenterChannelName = "";
        this.hifiCommunicator = null;
        this.receivedHiFiAudioAPIData.length = 0;
      }
      this.channelCntingTimer = 0;
      clearInterval(this.channelCntingTimerFun);
      this.channelCntingTimerFun = 0;
      this.channelDcntingTimer = 0;
      clearInterval(this.channelDcntingTimerFun);
    },
    hifiState(val) {
      if (this.wdWatch) {
        if (val == this.cntStatus.cnted) {
          this.$parent.showToast("Audio Service was connected!");
          setTimeout(() => {
            this.$parent.closeToast();
          }, 1000);
        } else {
          this.$parent.showToast(
            "Audio Service was disconnected. Reconnecting..."
          );
        }
      }
    },
    spatial(val) {},
    volumeThreshold(val) {
      this.setMicThreshold(val);
    },
    voiceVolume(val) {
      this.setVoiceVolume(val);
    },
    async isResetConnect(val) {
      if (val) {
        await this.disconnect();
        await this.connect();
      }
    },
  },
  created: function () {
    this.receiveDeviceId();
  },
  mounted: function () {
    this.watchdogFun = setInterval(this.watchdog, this.wdCheckTime);
    this.sendHifiAudioAPIDataFun = setInterval(
      this.sendHifiAudioAPIDataToFurioos,
      1000
    );
    this.userDataSubscription = new UserDataSubscription({
      callback: this.onNewUserDataReceived,
      components: this.subComponents,
      providedUserID: null,
    });
    HiFiLogger.setHiFiLogLevel(HiFiLogLevel.Debug);

    this.setVoiceVolume(this.voiceVolume);

    setInterval(() => {
      if (this.hifiState == "CONNECTED") {
        let v =
          this.hifiCommunicator._mixerSession
            ._lastSuccessfulInputAudioMutedValue;
        console.log("lastSuccessfulInputAudioMutedValue:", v);
      } else {
        console.log("lastSuccessfulInputAudioMutedValue: disconnected");
      }
    }, 3000);
  },
  methods: {
    async test() {},
    setWdWatch(val) {
      this.$emit("update:wdWatch", val);
    },
    toggleMic() {
      this.$emit("update:micEnabled", !this.micEnabled);
    },
    async watchdog() {
      if (this.isResetConnect) {
        console.log("hwatchdog: isresetconnect");
        return;
      }

      console.log("hwatchdog run", this.hifiState);
      if (this.wdWatch) {
        if (this.hifiState == this.cntStatus.cnting) {
          console.log("hWD:connecting");
          if (!this.isFirefox) {
            await this.disconnect();
            await this.connect();
          }
          return;
        }

        // if(this.channelCntingTimer>=11){
        //   await this.disconnect();
        //   await this.connect();
        //   this.channelCntingTimer=0;
        //   clearInterval(this.channelCntingTimerFun);
        //   this.channelDcntingTimer = 0;
        //   clearInterval(this.channelDcntingTimerFun);
        //   return;
        // }

        if (
          this.hifiState == this.cntStatus.dcnting &&
          this.channelDcntingTimer > 3
        ) {
          await this.disconnect();
          this.channelDcntingTimer = 0;
          clearInterval(this.channelDcntingTimerFun);
          this.hifiState = this.cntStatus.dcnted;
          return;
        }

        if (
          (this.hifiState == this.cntStatus.cnting ||
            this.hifiState == this.cntStatus.cnted) &&
          this.wdenterChannelName == this.receiveChannel
        ) {
          return;
        }
        if (this.wdenterChannelName != this.receiveChannel) {
          console.warn(
            "hWD:check channel error," +
              this.receiveChannel +
              " ? " +
              this.wdenterChannelName
          );
          if (this.hifiState == this.cntStatus.cnted) {
            console.log("hWD:reconnect:" + this.receiveChannel);
            await this.disconnect();
            await this.connect();
          } else if (this.hifiState == this.cntStatus.dcnted) {
            console.log("hWD:connect:" + this.receiveChannel);
            await this.connect();
          }
        } else if (
          this.wdenterChannelName == this.receiveChannel &&
          this.wdenterChannelName != ""
        ) {
          if (this.hifiState == this.cntStatus.dcnted) {
            console.warn("hWD:same channel, join when disconnected");
            await this.connect();
          }
        }
      } else {
        if (this.hifiState == this.cntStatus.cnted) {
          await this.disconnect();
        }
        this.wdenterChannelName = "";
      }
    },
    async connect() {
      if (this.hifiState == this.cntStatus.cnted) {
        console.log("hifi connected, return");
        return;
      }
      if (this.hifiState == this.cntStatus.cnting) {
        console.log("hifi connecting, return");
        return;
      }
      this.clearAllInterval();
      this.hifiState = this.cntStatus.cnting;
      this.wdenterChannelName = "";
      console.log("hifi connect");

      if (this.hifiCommunicator == null) {
        if (this.spatial) {
          this.hiFiAudioAPIData = new HiFiAudioAPIData({
            volumeThreshold: this.volumeThreshold,
            position: new Point3D({ x: 0, y: 0, z: 0 }),
            orientationEuler: new OrientationEuler3D({
              pitch: 0,
              yaw: 0,
              roll: 0,
            }),
            hiFiGain: 1,
            userAttenuation: -5,
            // userRolloff: this.rollOff,
          });
        } else {
          this.hiFiAudioAPIData = new HiFiAudioAPIData({
            volumeThreshold: this.volumeThreshold,
            position: new Point3D({ x: 0, y: 0, z: 0 }),
            orientationEuler: new OrientationEuler3D({
              pitch: 0,
              yaw: 0,
              roll: 0,
            }),
            hiFiGain: 0.125,
          });
        }

        this.hifiCommunicator = new HiFiCommunicator({
          initialHiFiAudioAPIData: this.hiFiAudioAPIData,
          onConnectionStateChanged: this.onConnectionStateChanged,
        });
      }

      if (this.micEnabled) {
        try {
          if (this.audioMediaStream != null) {
            const tracks = this.audioMediaStream.getTracks();
            tracks.forEach((track) => {
              track.stop();
            });
            this.audioMediaStream = undefined;
          }
          this.audioMediaStream = await navigator.mediaDevices.getUserMedia({
            audio: {
              deviceId: this.deviceId,
              echoCancellation: true,
              echoCancellationType: { ideal: "system" },
            },
            video: false,
          });

          this.$store.commit("updateMicPermission");
          console.log(this.audioMediaStream);
          await this.hifiCommunicator.setInputAudioMediaStream(
            this.audioMediaStream
          );
        } catch (error) {
          console.log("get mic permission error:", error);
          if (error.message == "Permission denied" || this.$parent.isFirefox) {
            this.$parent.showToast(
              "Microphone: You did not grant access so other cannot hear you. Please allow the page to access your microphone first."
            );
          } else {
            this.$parent.showToast(error.message);
          }
          return;
        }
      }

      if (this.channelCntingTimerFun == 0) {
        this.channelCntingTimerFun = setInterval(this.channelCntingCount, 1000);
      }

      try {
        this.wdenteringChannelName = this.receiveChannel;
        var jwt = require("jsonwebtoken");
        let data = {
          user_id: this.uid,
          app_id: this.appId,
          space_name: this.receiveChannel,
          admin: false,
          space_template_name: "150-user",
        };
        var token = jwt.sign(data, this.appSecret);
        let connectResult =
          await this.hifiCommunicator.connectToHiFiAudioAPIServer(
            token,
            this.apiUrl
          );
        this.hifiCommunicator.addUserDataSubscription(
          this.userDataSubscription
        );
        console.log(connectResult);
        if (connectResult.success) {
        } else {
          clearInterval(this.channelCntingTimerFun);
          this.channelCntingTimerFun = 0;
          throw "connect error:" + connectResult.error;
        }
      } catch (e) {
        console.error(`Error connecting to High Fidelity:` + e.error);
        clearInterval(this.channelCntingTimerFun);
        this.channelCntingTimerFun = 0;
        this.hifiState = this.cntStatus.dcnted;
        return;
      }
    },
    async disconnect() {
      if (
        this.hifiState == this.cntStatus.cnted ||
        this.hifiState == this.cntStatus.cnting ||
        this.hifiState == this.cntStatus.dcnting
      ) {
        this.hifiState = this.cntStatus.dcnting;
        this.channelDcntingTimerFun = setInterval(
          this.channelDcntingCount,
          1000
        );
        if (this.hifiCommunicator) {
          let result =
            await this.hifiCommunicator.disconnectFromHiFiAudioAPIServer();
          console.error("disconnect:", result);
          this.hifiCommunicator = null;
        }
      }
    },
    onConnectionStateChanged(val) {
      console.log("hifi state:", val);
      this.hifiSDKState =
        val.toUpperCase() == this.cntStatus.cnted
          ? this.cntStatus.cnted
          : this.cntStatus.dcnted;
    },
    webRTCStats(stats, prevStats) {
      // console.log(stats)
    },
    updateUserDataTransmit(position, euler, rollOff) {
      if (this.hifiState != this.cntStatus.cnted) {
        return;
      }
      this.hiFiAudioAPIData = {
        volumeThreshold: this.volumeThreshold,
        position: new Point3D({
          x: position[0],
          y: position[1],
          z: position[2],
        }),
        orientationEuler: new OrientationEuler3D({
          pitchDegrees: euler[0],
          yawDegrees: euler[1],
          rollDegrees: euler[2],
        }),
        // userRolloff: this.rollOff,
      };
      this.hifiCommunicator.updateUserDataAndTransmit(this.hiFiAudioAPIData);
    },
    onNewUserDataReceived(receivedHiFiAudioAPIDataArray) {
      // console.log('userSubData', receivedHiFiAudioAPIDataArray);
      this.receivedHiFiAudioAPIData = receivedHiFiAudioAPIDataArray;
      for (let i = 0; i < this.receivedHiFiAudioAPIData.length; i++) {
        if (
          this.receivedHiFiAudioAPIData[i].providedUserID == this.uid.toString()
        ) {
          this.selfMicVol = this.receivedHiFiAudioAPIData[i].volumeDecibels;
          break;
        }
      }
      if (this.maxUser < this.receivedHiFiAudioAPIData.length) {
        this.maxUser = this.receivedHiFiAudioAPIData.length;
      }
    },
    sendHifiAudioAPIDataToFurioos() {
      if (this.hifiState == this.cntStatus.cnted) {
        this.sendHifiAudioAPIData.length = 0;
        let vol = 0;
        for (let i = 0; i < this.receivedHiFiAudioAPIData.length; i++) {
          if (
            this.receivedHiFiAudioAPIData[i].volumeDecibels <
            this.volumeDeleteThreshold
          ) {
            continue;
          }
          vol = (this.receivedHiFiAudioAPIData[i].volumeDecibels + 100) / 100;
          this.sendHifiAudioAPIData.push({
            ProvidedUserID: this.receivedHiFiAudioAPIData[i].providedUserID,
            VolumeDecibels: vol,
          });
        }
        if (this.sendHifiAudioAPIData.length > 0) {
          this.$parent.sendRemoteAudioData(this.sendHifiAudioAPIData);
          this.receivedHiFiAudioAPIData.length = 0;
        }
      }
    },
    async setMute(val) {
      try {
        if (this.audioMediaStream != null) {
          const tracks = this.audioMediaStream.getTracks();
          tracks.forEach((track) => {
            track.stop();
          });
          this.audioMediaStream = undefined;
        }
        this.audioMediaStream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: this.inputDeviceId,
            echoCancellation: true,
            echoCancellationType: { ideal: "system" },
          },
          video: false,
        });

        this.$store.commit("updateMicPermission");
        console.log(this.audioMediaStream);
        if (this.hifiCommunicator != null) {
          await this.hifiCommunicator.setInputAudioMediaStream(
            this.audioMediaStream
          );
        }
      } catch (error) {
        console.log(error.message);
        if (error.message == "Permission denied" || this.$parent.isFirefox) {
          this.$parent.showToast(
            "Microphone: You did not grant access so other cannot hear you. Please allow the page to access your microphone first."
          );
        } else {
          this.$parent.showToast(error.message);
        }
        this.updateVauleToParent("micEnabled", false);
        this.$parent.sendFurioosMsg({
          sinewave: "microphone",
          enabled: !val,
          service: "hifi",
        });
        return;
      }
      let result = await this.hifiCommunicator.setInputAudioMuted(val);
      console.log("h set mute result:", result);
      if (!result) {
        this.$parent.sendFurioosMsg({
          sinewave: "microphone",
          enabled: !val,
          service: "hifi",
        });
      }
    },
    setMicThreshold(vol) {
      if (this.hifiState != this.cntStatus.cnted) {
        return;
      }
      this.hiFiAudioAPIData.volumeThreshold = vol;
      this.hifiCommunicator.updateUserDataAndTransmit(this.hiFiAudioAPIData);
    },
    setVoiceVolume(vol) {
      document.querySelector("#hifiSpeaker").volume = vol;
    },
    closeDevice: function () {
      this.$emit("update:micEnabled", false);
    },
    channelCntingCount: function () {
      this.channelCntingTimer++;
    },
    channelDcntingCount: function () {
      this.channelDcntingTimer++;
    },
    receiveDeviceId: function () {
      EventBus.$on("updateInputDeviceId", (deviceId) => {
        this.inputDeviceId = deviceId;
      });
    },
    clearAllInterval() {
      this.channelCntingTimer = 0;
      clearInterval(this.channelCntingTimerFun);
      this.channelCntingTimerFun = 0;

      this.channelDcntingTimer = 0;
      clearInterval(this.channelDcntingTimerFun);
    },
    updateVauleToParent(key, value) {
      this.$emit("update:" + key, value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SpatialAudio.vue